import React, { useEffect, useState } from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem
} from "@mui/material";

import api from "../../api/api";
import { createBillingRate } from "../../api/billingApi";

export default function RateFormDialog({ open, onClose }) {

  const [clients, setClients] = useState([]);
  const [projects, setProjects] = useState([]);
  const [users, setUsers] = useState([]);

  const [form, setForm] = useState({
    client_id: "",
    project_id: "",
    user_id: "",
    role: "",
    rate: "",
    currency: "USD",
    effective_from: ""
  });

  /* =========================
     LOAD DROPDOWN DATA
  ========================= */

  const loadData = async () => {

    try {

      const c = await api.get("/billing/clients");
      const p = await api.get("/projects/");
      const u = await api.get("/users/");

      setClients(c.data);
      setProjects(p.data);
      setUsers(u.data);

    } catch (err) {

      console.error("Dropdown load error", err);

    }

  };

  useEffect(() => {

    if (open) loadData();

  }, [open]);

  /* =========================
     HANDLE INPUT CHANGE
  ========================= */

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });

  };

  /* =========================
     SAVE RATE
  ========================= */

  const handleSubmit = async () => {

    try {

      await createBillingRate(form);

      onClose();

    } catch (err) {

      console.error("Create rate error", err);

    }

  };

  return (

    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>

      <DialogTitle>Add Billing Rate</DialogTitle>

      <DialogContent>

        {/* CLIENT SELECT */}

        <TextField
          select
          label="Client"
          name="client_id"
          fullWidth
          margin="normal"
          value={form.client_id}
          onChange={handleChange}
        >
          {clients.map((c) => (
            <MenuItem key={c.id} value={c.id}>
              {c.name}
            </MenuItem>
          ))}
        </TextField>


        {/* PROJECT SELECT */}

        <TextField
          select
          label="Project"
          name="project_id"
          fullWidth
          margin="normal"
          value={form.project_id}
          onChange={handleChange}
        >
          {projects.map((p) => (
            <MenuItem key={p.id} value={p.id}>
              {p.name}
            </MenuItem>
          ))}
        </TextField>

		
        {/* USER SELECT (OPTIONAL) */}

     

        {/* ROLE */}

        <TextField
          label="Role"
          name="role"
          fullWidth
          margin="normal"
          value={form.role}
          onChange={handleChange}
        />


        {/* RATE */}

        <TextField
          label="Rate (per hour)"
          name="rate"
          type="number"
          fullWidth
          margin="normal"
          value={form.rate}
          onChange={handleChange}
        />


        {/* CURRENCY */}

        <TextField
          label="Currency"
          name="currency"
          fullWidth
          margin="normal"
          value={form.currency}
          onChange={handleChange}
        />


        {/* EFFECTIVE DATE */}

        <TextField
          label="Effective From"
          name="effective_from"
          type="date"
          fullWidth
          margin="normal"
          InputLabelProps={{ shrink: true }}
          value={form.effective_from}
          onChange={handleChange}
        />

      </DialogContent>

      <DialogActions>

        <Button onClick={onClose}>
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={handleSubmit}
        >
          Save
        </Button>

      </DialogActions>

    </Dialog>

  );

}